const offerSecArr = document.querySelectorAll('.offer-sec');
const mobileMediaQuery = window.matchMedia('(max-width: 767px)');

if (offerSecArr.length) {
  offerSecArr.forEach((offerSec, sectionIndex) => {
    const offerTabsArr = offerSec.querySelectorAll('.offer-sec__tab');
    const offerItemsArr = offerSec.querySelectorAll('.offer-sec__item');
    const offerHeadsArr = offerSec.querySelectorAll('.offer-sec__item-head');
    const offerItemsCount = Math.min(offerTabsArr.length, offerItemsArr.length);
    const tabsEl = offerSec.querySelector('.offer-sec__tabs');
    let activeIndex = 0;
    let resizeFrame = null;
    let heightTimeout = null;

    if (!offerItemsCount) {
      return;
    }

    const getInitialActiveIndex = () => {
      const activeTabIndex = [...offerTabsArr].findIndex((tab, index) =>
        index < offerItemsCount && tab.classList.contains('is-active')
      );

      if (activeTabIndex >= 0) {
        return activeTabIndex;
      }

      const activeItemIndex = [...offerItemsArr].findIndex((item, index) =>
        index < offerItemsCount && item.classList.contains('is-active')
      );

      return activeItemIndex >= 0 ? activeItemIndex : 0;
    };

    const getItemHiddenContent = (item) =>
      item.querySelectorAll('.offer-sec__item-text, .offer-sec__item-bottom');

    const getClosedItemHeight = (item) => {
      const head = item.querySelector('.offer-sec__item-head');

      if (!head) {
        return item.scrollHeight;
      }

      const headStyles = window.getComputedStyle(head);
      const headMarginBottom = parseFloat(headStyles.marginBottom) || 0;

      return head.offsetTop + head.offsetHeight + headMarginBottom;
    };

    const setMobileItemHeights = () => {
      if (!mobileMediaQuery.matches) {
        offerItemsArr.forEach((item) => {
          item.style.maxHeight = '';
        });
        return;
      }

      offerItemsArr.forEach((item, index) => {
        if (index >= offerItemsCount) {
          item.style.maxHeight = '0px';
          return;
        }

        item.style.maxHeight =
          index === activeIndex ? `${item.scrollHeight + 2}px` : `${getClosedItemHeight(item)}px`;
      });
    };

    const queueMobileItemHeights = () => {
      if (!mobileMediaQuery.matches) {
        return;
      }

      if (resizeFrame) {
        window.cancelAnimationFrame(resizeFrame);
      }

      resizeFrame = window.requestAnimationFrame(() => {
        setMobileItemHeights();
      });

      if (heightTimeout) {
        window.clearTimeout(heightTimeout);
      }

      heightTimeout = window.setTimeout(() => {
        setMobileItemHeights();
      }, 460);
    };

    const setModeAttributes = () => {
      const isMobile = mobileMediaQuery.matches;

      if (tabsEl) {
        if (isMobile) {
          tabsEl.removeAttribute('role');
          tabsEl.removeAttribute('aria-orientation');
          tabsEl.setAttribute('aria-hidden', 'true');
        } else {
          tabsEl.setAttribute('role', 'tablist');
          tabsEl.setAttribute('aria-orientation', 'vertical');
          tabsEl.removeAttribute('aria-hidden');
        }
      }

      offerTabsArr.forEach((tab, index) => {
        const item = offerItemsArr[index];

        if (!item || index >= offerItemsCount) {
          tab.classList.remove('is-active');
          tab.setAttribute('aria-disabled', 'true');
          tab.setAttribute('tabindex', '-1');
          return;
        }

        const tabId = tab.id || `offer-tab-${sectionIndex}-${index}`;
        const itemId = item.id || `offer-panel-${sectionIndex}-${index}`;

        tab.id = tabId;
        item.id = itemId;
        tab.setAttribute('aria-controls', itemId);

        if (isMobile) {
          tab.removeAttribute('role');
          tab.setAttribute('aria-hidden', 'true');
          tab.setAttribute('tabindex', '-1');
          item.removeAttribute('role');
          item.removeAttribute('aria-labelledby');
        } else {
          tab.setAttribute('role', 'tab');
          tab.removeAttribute('aria-hidden');
          item.setAttribute('role', 'tabpanel');
          item.setAttribute('aria-labelledby', tabId);
        }
      });

      offerHeadsArr.forEach((head, index) => {
        const item = offerItemsArr[index];

        if (!item || index >= offerItemsCount) {
          return;
        }

        const headId = head.id || `offer-head-${sectionIndex}-${index}`;

        head.id = headId;

        if (isMobile) {
          head.setAttribute('role', 'button');
          head.setAttribute('tabindex', '0');
          head.setAttribute('aria-controls', item.id);
        } else {
          head.removeAttribute('role');
          head.removeAttribute('tabindex');
          head.removeAttribute('aria-controls');
          head.removeAttribute('aria-expanded');
        }
      });
    };

    const setActiveOffer = (nextIndex, shouldFocus = false, focusTarget = 'tab') => {
      const isMobile = mobileMediaQuery.matches;

      activeIndex = Math.max(0, Math.min(nextIndex, offerItemsCount - 1));

      offerTabsArr.forEach((tab, index) => {
        const isActive = index === activeIndex && index < offerItemsCount;

        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', String(isActive));
        tab.setAttribute('tabindex', !isMobile && isActive ? '0' : '-1');

        if (shouldFocus && focusTarget === 'tab' && isActive) {
          tab.focus();
        }
      });

      offerItemsArr.forEach((item, index) => {
        const isActive = index === activeIndex && index < offerItemsCount;

        item.classList.toggle('is-active', isActive);

        if (isMobile) {
          item.setAttribute('aria-hidden', 'false');
          item.removeAttribute('inert');

          getItemHiddenContent(item).forEach((contentEl) => {
            contentEl.setAttribute('aria-hidden', String(!isActive));
          });
        } else {
          item.setAttribute('aria-hidden', String(!isActive));

          getItemHiddenContent(item).forEach((contentEl) => {
            contentEl.removeAttribute('aria-hidden');
          });

          if (isActive) {
            item.removeAttribute('inert');
          } else {
            item.setAttribute('inert', '');
          }
        }
      });

      offerHeadsArr.forEach((head, index) => {
        const isActive = index === activeIndex && index < offerItemsCount;

        if (isMobile) {
          head.setAttribute('aria-expanded', String(isActive));

          if (shouldFocus && focusTarget === 'head' && isActive) {
            head.focus();
          }
        }
      });

      setMobileItemHeights();
      queueMobileItemHeights();
    };

    const focusMobileHead = (nextIndex) => {
      const head = offerHeadsArr[nextIndex];

      if (head) {
        head.focus();
      }
    };

    const refreshMobileHeights = () => {
      if (resizeFrame) {
        window.cancelAnimationFrame(resizeFrame);
      }

      resizeFrame = window.requestAnimationFrame(() => {
        setModeAttributes();
        setActiveOffer(activeIndex);
      });
    };

    offerTabsArr.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        if (!mobileMediaQuery.matches && !tab.classList.contains('is-active')) {
          setActiveOffer(index);
        }
      });

      tab.addEventListener('keydown', (event) => {
        if (mobileMediaQuery.matches) {
          return;
        }

        const lastIndex = offerItemsCount - 1;
        let nextIndex = index;

        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
          nextIndex = index === lastIndex ? 0 : index + 1;
        } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
          nextIndex = index === 0 ? lastIndex : index - 1;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = lastIndex;
        } else if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          setActiveOffer(index);
          return;
        } else {
          return;
        }

        event.preventDefault();
        setActiveOffer(nextIndex, true);
      });
    });

    offerItemsArr.forEach((item, index) => {
      item.addEventListener('click', () => {
        if (
          mobileMediaQuery.matches &&
          index < offerItemsCount &&
          !item.classList.contains('is-active')
        ) {
          setActiveOffer(index);
        }
      });
    });

    offerHeadsArr.forEach((head, index) => {
      head.addEventListener('keydown', (event) => {
        if (!mobileMediaQuery.matches) {
          return;
        }

        const lastIndex = offerItemsCount - 1;
        let nextIndex = index;

        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          setActiveOffer(index);
          return;
        }

        if (event.key === 'ArrowDown') {
          nextIndex = index === lastIndex ? 0 : index + 1;
        } else if (event.key === 'ArrowUp') {
          nextIndex = index === 0 ? lastIndex : index - 1;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = lastIndex;
        } else {
          return;
        }

        event.preventDefault();
        focusMobileHead(nextIndex);
      });
    });

    offerItemsArr.forEach((item, index) => {
      if (index < offerItemsCount) {
        return;
      }

      item.classList.remove('is-active');
      item.setAttribute('aria-hidden', 'true');
      item.setAttribute('inert', '');
    });

    activeIndex = getInitialActiveIndex();
    setModeAttributes();
    setActiveOffer(activeIndex);

    window.addEventListener('resize', refreshMobileHeights);
    window.addEventListener('load', refreshMobileHeights);

    if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
      document.fonts.ready.then(refreshMobileHeights);
    }

    if (mobileMediaQuery.addEventListener) {
      mobileMediaQuery.addEventListener('change', refreshMobileHeights);
    } else if (mobileMediaQuery.addListener) {
      mobileMediaQuery.addListener(refreshMobileHeights);
    }
  });
}
